module.exports = __webpack_public_path__ + "static/media/linkedin.43f8be06.svg";